module.exports = __webpack_public_path__ + "static/media/video-thumbnail-tabletPro-es.9d346c04.png";